import CheckoutFooter from './CheckoutFooter';

export default CheckoutFooter;
